import { render, staticRenderFns } from "./GeodirMapDeliveryPlanetChicken.vue?vue&type=template&id=524f4fa6"
import script from "./GeodirMapDeliveryPlanetChicken.vue?vue&type=script&lang=js"
export * from "./GeodirMapDeliveryPlanetChicken.vue?vue&type=script&lang=js"
import style0 from "./GeodirMapDeliveryPlanetChicken.vue?vue&type=style&index=0&id=524f4fa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports